// Utils
import { createDeepSelector } from '../../utils/milanoteReselect/milanoteReselect';
import { toArray } from '../../../common/utils/immutableHelper';
import { getElementId, getTableContentColWidthsGU } from '../../../common/elements/utils/elementPropertyUtils';
import { createSelector } from 'reselect';
import { getCurrentlyEditingEditorId } from '../selection/currentlyEditingSelector';
import { getTableCellEditorId } from './utils/tableEditorSessionUtils';
import { getSelectedElementIds } from '../selection/selectedElementsSelector';

export const getCurrentCellSelections = (state, { elementId, element }) => {
    elementId = elementId || getElementId(element);
    if (!elementId) return;

    const selectedElementIds = getSelectedElementIds(state);
    const isElementSingleSelected = selectedElementIds.size === 1 && selectedElementIds.first() === elementId;
    if (!isElementSingleSelected) return;

    return state.getIn(['app', 'selection', 'meta', 'currentCellSelections']);
};

/**
 * Used to get a memoized version of tableContent.colWidthsGU (in JS object format)
 */
export const getTableContentColWidthsGUSelector = () => {
    return createDeepSelector(
        (state, ownProps) => ownProps.element,
        (element) => {
            return toArray(getTableContentColWidthsGU(element)) || [];
        },
    );
};

export const isCurrentlyEditingTableCell = (elementId) =>
    createSelector(
        getCurrentlyEditingEditorId,
        (currentlyEditingEditorId) => currentlyEditingEditorId === getTableCellEditorId(elementId),
    );
